let production_base_url = {
    LOGIN_API: 'https://antheapi.aakash.ac.in/api/login_access',
    DASHBOARD_API: 'https://antheapi.aakash.ac.in/api/dashboard',
    EXAM_INFO_API: 'https://antheapi.aakash.ac.in/api/exam_info',
    MASTER_API: 'https://antheapi.aakash.ac.in/api/master_data',
    SCHOOL_API: 'https://antheapi.aakash.ac.in/api/get-school-list/',
    EXAM_DATES_API: 'https://antheapi.aakash.ac.in/api/exam_dates_slots',
    GENERATE_OTP_API: 'https://antheapi.aakash.ac.in/api/generate_otp_login',
    VALIDATE_OTP_API: 'https://antheapi.aakash.ac.in/api/verify_otp_login',
    UPDATE_EXAM_INFO_API: 'https://antheapi.aakash.ac.in/api/exam_info_update',
    START_MAIN_EXAM_API: 'https://antheapi.aakash.ac.in/api/start-main-journey',
    RESET_SAMPLE_EXAM_API: 'https://antheapi.aakash.ac.in/api/reset-sample',
    RESULT_API: 'https://antheapi.aakash.ac.in/api/user_result',
    IACST_RESULT_API: 'https://anthe-cms.aakash.ac.in/api/get-iacst-result',
    PROFILE_API: 'https://antheapi.aakash.ac.in/api/profile',
    PROFILE_UPDATE_API: 'https://antheapi.aakash.ac.in/api/profile-update',
    MOCK_PAYMENT_API: `https://antheapi.aakash.ac.in/api/payment-options`,
    FORGOT_PASSWORD: 'https://antheapi.aakash.ac.in/api/anthe_forgot_password',
    EXIGENCY_DATE_TIME_API:
        'https://antheapi.aakash.ac.in/api/exigency_registration_date_time_check',
    EXIGENCY_GENERATE_OTP_API:
        'https://antheapi.aakash.ac.in/api/exigency_generate_otp',
    EXIGENCY_VERIFY_OTP_API:
        'https://antheapi.aakash.ac.in/api/exigency_validate_otp',
    EXIGENCY_USER_REGISTER_API:
        'https://antheapi.aakash.ac.in/api/exigency_user_register',
    REGISTER_URL: 'https://anthe.aakash.ac.in/anthe',
    FETCH_BRANCHES: 'https://antheapi.aakash.ac.in/api/nearest-center/',
    ANTHE_DRUPAL_LANDING: 'https://anthe.aakash.ac.in/anthe',
    AKTHE_DRUPAL_LANDING: 'https://akthe.aakash.ac.in/anthe-kashmir',
    GOOGLE_MAPS_API_KEY: 'AIzaSyB0gaOAOb1k3eCefik2cXwEYlHef2XzzYY',
    GOOGLE_MAPS_ID: '',
    MAPS_CENTER: {
        lat: 22.863454,
        lng: 78.715780
    },
    GET_ALL_CENTERS_LOCATION: 'https://antheapi.aakash.ac.in/api/get-allcenters-cordinates',
    TP_TOKEN_API: 'https://testplayerapi-prod.aakash.ac.in/Prod/test_player/websiteToken',
    TP_TOKEN_API_TOKEN: 'scholarship-website_WXD3ZnuMa5k4IEE4',
    TP_RESULT_DATA: 'https://testplayerapi-prod.aakash.ac.in/Prod/test_player/anthe-result',
    GET_PSID: " https://antheapi.aakash.ac.in/api/get-user-psid",
    IACST_LANDING_PAGE: "https://iacst.aakash.ac.in/iacstexam",
    FETCH_COURSE_DATA: 'https://aakashapi.aakash.ac.in/api/course/list',
    PINCODE_API: 'https://aakashapi.aakash.ac.in/online-form/address',
    COURSE_PAYMENT_API: 'https://aakashapi.aakash.ac.in/api/get-course-payment-data',
    STATE_API: 'https://aakashapi.aakash.ac.in/online-form/state',
    IP_INFO_API_KEY: '2fd8098a9b861f684efb7e036869ebbf3d03439fc16111adeab58998',
    LEPTON_MAP_API_KEY: 'da84163694c8df35961b7256e7ffcd19004702fb8b23d580da16e51c0687cf5c',
    CENTER_PAYMENT_GATEWAY_API:'https://antheapi.aakash.ac.in/examapi/get_center_payment_gateway_list/',
    TP_URL_LINK: 'https://antheapi.aakash.ac.in/examapi/get_examUrl',
}

let uat_base_url = {
    LOGIN_API: 'https://antheapi-qa.aakash.ac.in/api/login_access',
    DASHBOARD_API: 'https://antheapi-qa.aakash.ac.in/api/dashboard',
    EXAM_INFO_API: 'https://antheapi-qa.aakash.ac.in/api/exam_info',
    MASTER_API: 'https://antheapi-qa.aakash.ac.in/api/master_data',
    SCHOOL_API: 'https://antheapi-qa.aakash.ac.in/api/get-school-list/',
    EXAM_DATES_API: 'https://antheapi-qa.aakash.ac.in/api/exam_dates_slots',
    GENERATE_OTP_API: 'https://antheapi-qa.aakash.ac.in/api/generate_otp_login',
    VALIDATE_OTP_API: 'https://antheapi-qa.aakash.ac.in/api/verify_otp_login',
    UPDATE_EXAM_INFO_API: 'https://antheapi-qa.aakash.ac.in/api/exam_info_update',
    START_MAIN_EXAM_API: 'https://antheapi-qa.aakash.ac.in/api/start-main-journey',
    RESET_SAMPLE_EXAM_API: 'https://antheapi-qa.aakash.ac.in/api/reset-sample',
    RESULT_API: 'https://antheapi-qa.aakash.ac.in/api/user_result',
    IACST_RESULT_API: 'https://anthe-kell-cms.aakash.ac.in/api/get-iacst-result',
    FORGOT_PASSWORD: 'https://antheapi-qa.aakash.ac.in/api/anthe_forgot_password',
    PROFILE_API: 'https://antheapi-qa.aakash.ac.in/api/profile',
    PROFILE_UPDATE_API: 'https://antheapi-qa.aakash.ac.in/api/profile-update',
    MOCK_PAYMENT_API: `https://antheapi-qa.aakash.ac.in/api/payment-options`,
    EXIGENCY_DATE_TIME_API:
        'https://antheapi-qa.aakash.ac.in/api/exigency_registration_date_time_check',
    EXIGENCY_GENERATE_OTP_API:
        'https://antheapi-qa.aakash.ac.in/api/exigency_generate_otp',
    EXIGENCY_VERIFY_OTP_API:
        'https://antheapi-qa.aakash.ac.in/api/exigency_validate_otp',
    EXIGENCY_USER_REGISTER_API:
        'https://antheapi-qa.aakash.ac.in/api/exigency_user_register',
    REGISTER_URL: 'https://anthe-kell.aakash.ac.in/anthe',
    FETCH_BRANCHES: 'https://antheapi-qa.aakash.ac.in/api/nearest-center/',
    ANTHE_DRUPAL_LANDING: 'https://anthe-kell.aakash.ac.in/anthe',
    AKTHE_DRUPAL_LANDING: 'https://uat-akthe.aakash.ac.in/anthe-kashmir',
    GOOGLE_MAPS_API_KEY: 'AIzaSyB0gaOAOb1k3eCefik2cXwEYlHef2XzzYY',
    GOOGLE_MAPS_ID: '',
    MAPS_CENTER: {
        lat: 22.863454,
        lng: 78.715780
    },
    GET_ALL_CENTERS_LOCATION: 'https://antheapi-qa.aakash.ac.in/api/get-allcenters-cordinates',
    TP_TOKEN_API: 'https://testplayerapi-qa.aakash.ac.in/stage/test_player/websiteToken',
    TP_TOKEN_API_TOKEN: 'scholarship-website_R4tOTJq72gwx2Rex',
    TP_RESULT_DATA: 'https://testplayerapi-qa.aakash.ac.in/stage/test_player/anthe-result',
    GET_PSID: "https://antheapi-qa.aakash.ac.in/api/get-user-psid",
    IACST_LANDING_PAGE: "https://uat-iacst.aakash.ac.in/iacstexam",
    FETCH_COURSE_DATA: 'https://cms-sit.aakash.ac.in/api/course/list',
    PINCODE_API: 'https://cms-sit.aakash.ac.in/online-form/address',
    COURSE_PAYMENT_API: 'https://cms-sit.aakash.ac.in/api/get-course-payment-data',
    STATE_API: 'https://cms-sit.aakash.ac.in/online-form/state',
    IP_INFO_API_KEY: '2fd8098a9b861f684efb7e036869ebbf3d03439fc16111adeab58998',
    LEPTON_MAP_API_KEY: 'da84163694c8df35961b7256e7ffcd19004702fb8b23d580da16e51c0687cf5c',
    CENTER_PAYMENT_GATEWAY_API:'https://antheapi-qa.aakash.ac.in/examapi/get_center_payment_gateway_list/',
    TP_URL_LINK: 'https://antheapi-qa.aakash.ac.in/examapi/get_examUrl',
}

let config = {}

if (process.env.REACT_APP_ENVIRONMENT === 'production') {
    config = production_base_url
} else if (process.env.REACT_APP_ENVIRONMENT === 'uat') {
    config = uat_base_url
} else {
    config = uat_base_url
}

export default config
